import { render } from "./ProductVariant.vue?vue&type=template&id=a428dd62"
import script from "./ProductVariant.vue?vue&type=script&lang=js"
export * from "./ProductVariant.vue?vue&type=script&lang=js"
script.render = render

export default script